/**
 * El círculo de color con el ícono de una notificación. Lo comparten la campana y la página de todas las
 * notificaciones: el mismo aviso se reconoce igual en los dos lugares.
 */
import { Icon } from '@/lib/polaris';
import {
  NotificationIcon, ChatIcon, OrderIcon, AlertTriangleIcon, CashDollarIcon,
} from '@/lib/polaris-icons';

/**
 * Ícono y color por familia de notificación. El prefijo del `type` ("order.paid", "wa.mention")
 * alcanza: agrupa sin obligar a mantener una lista de todos los tipos, que crece cada vez que
 * alguien agrega uno.
 */
function pinta(tipo: string): { icono: typeof NotificationIcon; fondo: string } {
  const familia = tipo.split('.')[0];
  switch (familia) {
    case 'order': return { icono: OrderIcon, fondo: '#2C6ECB' };
    case 'wa': case 'chat': case 'message': return { icono: ChatIcon, fondo: '#25D366' };
    case 'payment': case 'cobranza': return { icono: CashDollarIcon, fondo: '#00848E' };
    case 'copilot': case 'alert': case 'integration': return { icono: AlertTriangleIcon, fondo: '#B98900' };
    default: return { icono: NotificationIcon, fondo: '#5C5F62' };
  }
}

export function InsigniaDelAviso({ tipo }: { tipo: string }) {
  const { icono, fondo } = pinta(tipo);
  return (
    <span style={{
      width: 40, height: 40, borderRadius: '50%', background: fondo, color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <span style={{ width: 20, height: 20, display: 'block' }}>
        <Icon source={icono} tone="inherit" />
      </span>
    </span>
  );
}

